export const initGTM = () => {
  const gtmId = process.env.REACT_APP_GTM_ID;
  if (!gtmId) return;

  // scriptタグを挿入
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  // dataLayerの初期化
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
};
